import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Image } from '@ravago/shared/radiance/components/image/components/Image/Image';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface ConfirmRegistrationProps {
   handleLogin: () => void;
}

export const ConfirmRegistration: FC<ConfirmRegistrationProps> = ({ handleLogin }) => {
   const translate = useTranslations();

   return (
      <Box direction="column" justify="center" items="center" gap="2xl">
         <Image src="/images/registration-success.png" alt="Registration success" title="Registration success" width="208px" />
         <Box direction="column" justify="center" items="center" gap="lg">
            <Typography component="h1" align="center" variant="heading-1">
               {translate('auth.confirm-registration-title')}
            </Typography>
            <Typography component="p" align="center" variant="body" color="strong">
               {translate('auth.confirm-registration-description-1')}{' '}
               <Typography component="span" align="center" variant="body-highlight" color="inherit">
                  {translate('auth.confirm-registration-description-2')}{' '}
               </Typography>
               <Typography component="span" align="center" variant="body" color="inherit">
                  {translate('auth.confirm-registration-description-3')}
               </Typography>
            </Typography>
            <Button variant="primary" onClick={handleLogin}>
               {translate('auth.confirm-registration-back-button')}
            </Button>
         </Box>
      </Box>
   );
};
